import React, { useState, useEffect } from "react";
import api from "../../../utils/api"
import { Container, Button, Modal, ModalBody } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

const GuestCart = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tenant = params.get("tenant");

  const [cart, setCart] = useState([]);
  const [addonsList, setAddonsList] = useState([]);
  const [addons, setAddons] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [tableNo, setTableNo] = useState(null);
  const [offers, setOffers] = useState([]);
const [appliedOffer, setAppliedOffer] = useState(null);
const [placingOrder, setPlacingOrder] = useState(false);

  /* ---------------- LOAD TABLE ---------------- */

  useEffect(() => {
    const t = localStorage.getItem("tableNo");
    if (t) setTableNo(t);
    else {
      alert("Table not found — scan QR again");
      navigate("/");
    }
  }, []);

  useEffect(() => {
  if (appliedOffer && !isOfferValid(appliedOffer)) {
    setAppliedOffer(null);
  }
}, [cart, addons]);

  /* ---------------- LOAD CART ---------------- */

  useEffect(() => {
    const saved = localStorage.getItem("guestCart");
    if (saved) setCart(JSON.parse(saved));
  }, []);

  const saveCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem("guestCart", JSON.stringify(newCart));
  };

  useEffect(() => {
  if (!tenant) return;

  const fetchOffers = async () => {
    try {
      const { data } = await api.get("/guest/offers", {
        params: { tenant }
      });
      setOffers(data);
    } catch (err) {
      console.error("Offer fetch failed", err);
    }
  };

  fetchOffers();
}, [tenant]);

  /* ---------------- CART ACTIONS ---------------- */

  const incQty = (idx) => {
    const updated = [...cart];
    updated[idx].qty = Number(updated[idx].qty) + 1;
    saveCart(updated);
  };

  const decQty = (idx) => {
    const updated = [...cart];
    if (updated[idx].qty > 1) {
      updated[idx].qty -= 1;
      saveCart(updated);
    } else {
      removeItem(idx);
    }
  };

  const removeItem = (idx) => {
    const updated = cart.filter((_, i) => i !== idx);
    saveCart(updated);
  };

  /* ---------------- ORDER TYPE DETECTION ---------------- */

  const getOrderTypes = () => {
    const types = new Set(cart.map(i => i.serviceType));
    return types;
  };

  /* ---------------- FETCH ADDONS ---------------- */

  useEffect(() => {
    if (!cart.length) return;

    const fetchAddons = async () => {
      try {


      const { data } = await api.get("/guest/addons", {
  params: { tenant }
});

const types = getOrderTypes();

const filtered = data
  .filter(a => {
    if (types.has("restaurant") && types.has("bar")) return true;
    if (types.has("restaurant")) return a.category === "Restaurant";
    if (types.has("bar")) return a.category === "Bar";
    return false;
  })
  .map(a => ({
    ...a,
    price: a.sellingPrice
  }));

setAddonsList(filtered);

      } catch (e) {
        console.error("Addon fetch failed", e);
      }
    };

    fetchAddons();
  }, [cart, tenant]);




  /* ---------------- TOTALS ---------------- */

  const restaurantTotal = cart
  .filter(i => i.serviceType === "restaurant")
  .reduce((sum, i) => sum + Number(i.price) * Number(i.qty), 0);

const barTotal = cart
  .filter(i => i.serviceType === "bar")
  .reduce((sum, i) => sum + Number(i.price) * Number(i.qty), 0);

  /* ---------------- TOTALS ---------------- */

const isOfferValid = (offer) => {
  const now = new Date();

  if (offer.status !== "Active") return false;
  if (new Date(offer.validFrom) > now) return false;
  if (new Date(offer.validTo) < now) return false;

  // Default type if not present
  const type = offer.offerType || "both";

  if (type === "restaurant") {
    return restaurantTotal >= Number(offer.minOrderAmount);
  }

  if (type === "bar") {
    return barTotal >= Number(offer.minOrderAmount);
  }

  if (type === "both") {
    return grandTotal >= Number(offer.minOrderAmount);
  }

  return false;
};


  const cartTotal = cart.reduce(
    (sum, i) => sum + Number(i.price) * Number(i.qty),
    0
  );

 const addonsTotal = addons.reduce(
  (sum, a) => sum + Number(a.sellingPrice),
  0
);
const grandTotal = cartTotal + addonsTotal;
const discountAmount = appliedOffer ? appliedOffer.discountAmount : 0;
const finalTotal = grandTotal - discountAmount;

  /* ---------------- ADDON TOGGLE ---------------- */

  const toggleAddon = (addon) => {
    setAddons(prev =>
      prev.find(a => a._id === addon._id)
        ? prev.filter(a => a._id !== addon._id)
        : [...prev, addon]
    );
  };

  /* ---------------- PLACE ORDER ---------------- */

 const handlePlaceOrder = async () => {
  if (placingOrder) return;

  if (!cart.length) {
    alert("Cart empty");
    return;
  }

  if (!grandTotal || isNaN(grandTotal)) {
    alert("Invalid total");
    return;
  }

  if (cart.some(i => !i.menuItemId)) {
    alert("Invalid cart items");
    return;
  }

  try {
    setPlacingOrder(true);

    const payload = {
      tenantId: tenant,
      tableNo,
      mealCategory: "Lunch",
      mealType: "Veg",
      paymentType: "Cash",
      totalAmount: grandTotal,
      offerId: appliedOffer?._id || null,

      items: cart.map(i => ({
        tenantId: tenant,
        menuItemId: i.menuItemId,
        name: i.name,
        quantity: Number(i.qty),
        price: Number(i.price),
        type: i.serviceType === "bar" ? "Bar" : "Food",
        category: i.serviceType === "bar" ? "BAR" : "RESTAURANT",
        plateType: i.plateType,
        size: i.size || "",
        image: i.image || "",
        addons: addons.map(a => ({
          addonId: a._id,
          name: a.name,
          price: Number(a.price)   // ✅ normalized field
        }))
      }))
    };

    console.log("📨 FINAL ORDER PAYLOAD =", payload);

    const { data: createdOrder } = await api.post(
      "/guest/orders",
      payload,
      { params: { tenant } }
    );

    const originalTotal = createdOrder.totalAmount;
    const discount = appliedOffer?.discountAmount || 0;
    const finalAmount = Math.max(originalTotal - discount, 0);

    console.log("Original:", originalTotal);
    console.log("Discount:", discount);
    console.log("Final:", finalAmount);

    // ✅ Save current order
    localStorage.setItem(
      "currentOrder",
      JSON.stringify({
        orderId: createdOrder._id,
        items: createdOrder.items,
        totalAmount: originalTotal,
        discount,
        finalAmount,
        status: createdOrder.status,
        orderPlaced: true,
        paid: false
      })
    );

    // ✅ Clear cart
    localStorage.removeItem("guestCart");
    setCart([]);
    setAppliedOffer(null);
    setAddons([]);

    setShowSuccess(true);

  } catch (err) {
    console.error(err);
    alert(err.response?.data?.message || "Order failed");
  } finally {
    setPlacingOrder(false);
  }
};

  /* ---------------- UI ---------------- */

  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh" }}>

      {/* HEADER */}
      <div style={{
        background: "#fff",
        padding: "14px 16px",
        display: "flex",
        gap: 12,
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
      }}>
        <i
          className="ri-arrow-left-line fs-5"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h5>Your Cart</h5>
      </div>

      <Container className="py-3">

        {/* CART ITEMS */}
        <div className="bg-white rounded p-3 mb-3">
          {cart.map((item, idx) => (
            <div key={idx}
              className="d-flex justify-content-between mb-3">

              <div className="d-flex gap-3">
                <img src={item.image}
                  style={{ width:50, height:50, borderRadius:10 }} />

                <div>
                  <strong>{item.name}</strong>

                  <div className="d-flex gap-2 mt-1">
                    <Button size="sm" onClick={()=>decQty(idx)}>-</Button>
                    <strong>{item.qty}</strong>
                    <Button size="sm" onClick={()=>incQty(idx)}>+</Button>
                    <Button size="sm" color="danger"
                      onClick={()=>removeItem(idx)}>
                      Remove
                    </Button>
                  </div>

                  <small>{item.size}</small>
                </div>
              </div>

              <strong>₹{item.price * item.qty}</strong>
            </div>
          ))}

          {!cart.length && (
            <div className="text-center text-muted">Cart empty</div>
          )}
        </div>

        {/* ADDONS */}
        {!!addonsList.length && (
          <div className="bg-white rounded p-3 mb-3">
            <h6>Add-ons</h6>

            <div className="d-flex gap-2 flex-wrap">
              {addonsList.map(a => {
                const selected = addons.find(x => x._id === a._id);
                return (
                  <div key={a._id}
                    onClick={()=>toggleAddon(a)}
                    style={{
                      padding:"6px 14px",
                      border:"1px solid #ccc",
                      borderRadius:20,
                      cursor:"pointer",
                      background:selected?"#e6ffe6":"#fff"
                    }}>
                    {a.name} ₹{a.sellingPrice}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <h6 className="text-muted">Table: {tableNo}</h6>

        {/* COUPONS SECTION */}
{!!offers.length && (
  <div className="bg-white rounded p-3 mb-3">
    <h6>Available Coupons</h6>

    {offers.map(o => {
      const valid = isOfferValid(o);

      return (
        <div key={o._id}
          className="d-flex justify-content-between align-items-center mb-2"
          style={{
            padding: 10,
            border: "1px solid #ddd",
            borderRadius: 8,
            background: valid ? "#f8fff8" : "#f5f5f5",
            opacity: valid ? 1 : 0.6
          }}>

          <div>
            <strong>{o.title}</strong>
            <div style={{ fontSize: 12 }}>
              {o.note}
            </div>
          </div>

          <Button
            size="sm"
            color={appliedOffer?._id === o._id ? "success" : "primary"}
            disabled={!valid}
            onClick={() => setAppliedOffer(o)}
          >
            {appliedOffer?._id === o._id ? "Applied" : "Apply"}
          </Button>
        </div>
      );
    })}
  </div>
)}

        {/* TOTAL */}
       <div className="bg-white rounded p-3 mb-4">
  <div className="d-flex justify-content-between">
    <span>Items</span><strong>₹{cartTotal}</strong>
  </div>

  <div className="d-flex justify-content-between">
    <span>Addons</span><strong>₹{addonsTotal}</strong>
  </div>

  {appliedOffer && (
    <div className="d-flex justify-content-between text-success">
      <span>Coupon Discount</span>
      <strong>- ₹{appliedOffer.discountAmount}</strong>
    </div>
  )}

  <hr/>

  <div className="d-flex justify-content-between fs-5">
    <strong>Total</strong>
    <strong>₹{finalTotal}</strong>
  </div>
</div>

       <Button
  color="success"
  block
  disabled={!cart.length || placingOrder}
  onClick={handlePlaceOrder}
>
  {placingOrder ? "Placing..." : "Place Order"}
</Button>

      </Container>

      {/* SUCCESS MODAL */}
      <Modal isOpen={showSuccess} centered>
        <ModalBody className="text-center">
          <h5>✅ Order Placed</h5>
          <Button color="success"
            onClick={()=>{
              setShowSuccess(false);
              navigate(`/apps-bookings?tenant=${tenant}`);
            }}>
            OK
          </Button>
        </ModalBody>
      </Modal>

    </div>
  );
};

export default GuestCart;
